/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import HabitsHistory from './habits-history';
import HabitsHistoryDetail from './habits-history-detail';
import HabitsHistoryUpdate from './habits-history-update';
import HabitsHistoryDeleteDialog from './habits-history-delete-dialog';

const HabitsHistoryRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<HabitsHistory />} />
    <Route path="new" element={<HabitsHistoryUpdate />} />
    <Route path=":id">
      <Route index element={<HabitsHistoryDetail />} />
      <Route path="edit" element={<HabitsHistoryUpdate />} />
      <Route path="delete" element={<HabitsHistoryDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default HabitsHistoryRoutes;
